import { useMemo } from "react";
import { layoutGraph, type NodeInput, type EdgeInput } from "../../lib/topology";
import { Node } from "./Node";
import { Edge } from "./Edge";

export function Graph({
  nodes,
  edges,
  width = 600,
  height = 360,
  activeEdges,
}: {
  nodes: NodeInput[];
  edges: EdgeInput[];
  width?: number;
  height?: number;
  activeEdges?: Set<string>;
}) {
  const { nodes: ln, edges: le } = useMemo(
    () => layoutGraph({ nodes, edges, width, height }),
    [nodes, edges, width, height],
  );

  const edgeKey = (e: EdgeInput) => `${e.source}->${e.target}`;

  return (
    <svg className="topology-canvas" width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      {le.map((e) => <Edge key={edgeKey(e)} edge={e} active={activeEdges?.has(edgeKey(e))} />)}
      {ln.map((n) => <Node key={n.id} node={n} />)}
    </svg>
  );
}
